import styles from './label.module.scss';
import { LabelType } from './label.types';

interface LabelProps {
  text: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  status?: LabelType;
}

export default function Label({
  text,
  status = 'default',
  isDisabled = false,
  isRequired,
}: LabelProps) {
  return (
    <label
      className={`${styles.label} ${status === 'default' ? '' : styles[`label-${status}`]} ${isDisabled ? styles[`label-disabled`] : ''}`}
    >
      {isRequired ? `${text} *` : text}
    </label>
  );
}
